var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-well w-100"},[_c('div',{staticClass:"well-segment"},[_c('ul',{staticClass:"blob-commit-info"},[_c('commit-item',{attrs:{"commit":_vm.commit}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }